import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { FullLayoutComponent } from "../containers/full-layout/full-layout.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AuthguardService } from "../shared";
import { PortalLanguageComponent } from "../manager/portal-language/portal-language.component";
import { UsersComponent } from "./users/users.component";
import { UsersListComponent } from "./users-list/users-list.component";
import { PushParentQuestionBankListComponent } from "../manager/push-parent-question-bank-list/push-parent-question-bank-list.component";
import { PushParentQuestionBankComponent } from "../manager/push-parent-question-bank/push-parent-question-bank.component";
import { DefineQuestionTypeComponent } from "../manager/define-question-type/define-question-type.component";
import { AppHeaderComponent } from "../manager/app-header/app-header.component";
import { UploadExamCenterComponent } from "./upload-exam-center/upload-exam-center.component";
import { ConstantConfigurationComponent } from "../manager/constant-configuration/constant-configuration.component";
import { UploadCSRCComponent } from "../manager/csrc/upload-csrc/upload-csrc.component";
import { UploadTestTimingComponent } from "../manager/upload-test-timing/upload-test-timing.component";
import { LanguageListComponent } from "../manager/language-list/language-list.component";
import { CSRCListComponent } from "../manager/csrc/csrc.component";
import { JobsComponent } from "./jobs/jobs.component";
import { CandidateListComponent } from "./candidate-list/candidate-list.component";
import { UploadTestCenterUserComponent } from "./upload-test-center-user/upload-test-center-user.component";
import { UploadTestCenterUserListComponent } from "../manager/upload-test-center-user/upload-test-center-user-list/upload-test-center-user-list.component";
import { CandidateDetailsComponent } from "./candidate-list/candidate-details/candidate-details.component";
import { CsrcDetailsComponent } from "../manager/csrc/csrc-details/csrc-details.component";
import { TestCenterUserComponent } from "../manager/upload-test-center-user/test-center-user/test-center-user.component";
import { UploadTestScheduleComponent } from "../manager/upload-test-schedule/upload-test-schedule.component";
import { TestScheduleComponent } from "../manager/upload-test-schedule/test-schedule/test-schedule.component";
import { CandidateScheduleComponent } from "../manager/upload-test-schedule/candidate-schedule/candidate-schedule.component";
import { UploadExamOSComponent } from "../manager/upload-exam-os/upload-exam-os.component";
import { QuestionBatchComponent } from './question-batch/question-batch.component';
import { MacAddressListComponent } from '../manager/mac-address-list/mac-address-list.component';
import { MacAddressDetailsComponent } from './mac-address-list/mac-address-details/mac-address-details.component';
import { UploadMacAddressComponent } from './mac-address-list/upload-mac-address/upload-mac-address.component';
import { TestBatchComponent } from './test-batch/test-batch.component';
import { JoblogComponent } from './jobs/joblog/joblog.component';
import { FtpDetailsComponent } from './ftp-details/ftp-details.component';



const routes: Routes = [
  {
    path: "manager",
    data: {
      title: ""
    },
    canActivate: [AuthguardService],
    component: FullLayoutComponent,
    children: [
      {
        path: "",
        data: {
          title: "Dashboard Page"
        },
        component: DashboardComponent
      },
      {
        path: "tests",
        loadChildren: () =>
          import("./exam-list/exam.module").then(m => m.ExamModule)
      },
      {
        path: "dashboard",
        data: {
          title: "Dashboard"
        },
        component: DashboardComponent
      },

      {
        path: "portal-language",
        data: {
          title: "Portal Language"
        },
        component: PortalLanguageComponent
      },

      {
        path: "user/:id",
        data: {
          title: "User Detail"
        },
        component: UsersComponent
      },
      {
        path: "users",
        data: {
          title: "Users"
        },
        component: UsersListComponent
      },

      {
        path: "define-question-type",
        data: {
          title: "Define Question Type"
        },
        component: DefineQuestionTypeComponent
      },

      {
        path: "constant-configuration",
        data: {
          title: "Constant Configuration"
        },
        component: ConstantConfigurationComponent
      },
      {
        path: "csrc",
        data: {
          title: "CSRC List"
        },
        component: CSRCListComponent
      },
      {
        path: "csrc-detail/:id",
        data: {
          title: "CSRC List"
        },
        component: CsrcDetailsComponent
      },
      {
        path: "csrc/upload",
        data: {
          title: "Upload CSRC"
        },
        component: UploadCSRCComponent
      },
      {
        path: "upload-exam-center/:id",
        data: {
          title: "Upload Exam Center"
        },
        component: UploadExamCenterComponent
      },
      {
        path: "upload-test-timing/:id",
        data: {
          title: "Upload Test Timing"
        },
        component: UploadTestTimingComponent
      },
      {
        path: "app-header",
        data: {
          title: "Applicstion Header"
        },
        component: AppHeaderComponent
      },
      {
        path: "languages",
        data: {
          title: "Language List"
        },
        component: LanguageListComponent
      },
      {
        path: "batches",
        data: {
          title: "test batch"
        },
        component: TestBatchComponent
      },
      {
        path: "jobs",
        data: {
          title: "jobs"
        },
        component: JobsComponent
      },
      {
        path: "jobs/:id/logs",
        data: {
          title: "jobs"
        },
        component: JoblogComponent
      },
      {
        path: "ftp",
        component: FtpDetailsComponent
      },
      {
        path: "candidate-list",
        data: {
          title: "Candidate List"
        },
        component: CandidateListComponent
      },
      {
        path: "push-parent-question-bank-list",
        data: {
          title: "Push Parent Question Bank List"
        },
        component: PushParentQuestionBankListComponent
      },
      {
        path: "push-parent-question-bank/:id",
        data: {
          title: "Push Parent Question Bank"
        },
        component: PushParentQuestionBankComponent
      },
      {
        path: "upload-test-center-user/:id",
        data: {
          title: "Upload Test Center User"
        },
        component: UploadTestCenterUserComponent
      },
      {
        path: "upload-test-center-user-list",
        data: {
          title: "Upload Test Center User"
        },
        component: UploadTestCenterUserListComponent
      },

      {
        path: "testcenter/:id",
        data: {
          title: "Test Center User"
        },
        component: TestCenterUserComponent
      },
      {
        path: "candidate/:id",
        data: {
          title: "Candidate Details"
        },
        component: CandidateDetailsComponent
      },
      {
        path: "upload-test-schedule",
        data: {
          title: "Upload Test Schedule"
        },
        component: UploadTestScheduleComponent
      },
      {
        path: "test-schedule/upload",
        data: {
          title: "Test Schedule"
        },
        component: TestScheduleComponent
      },
      {
        path: "candidate-schedule/:id",
        data: {
          title: "Candidate Schedule"
        },
        component: CandidateScheduleComponent
      },
      {
        path: "qb-batch",
        data: {
          title: "Question Batch"
        },
        component: QuestionBatchComponent
      },

      {
        path: "mac-address-details/:id",
        data: {
          title: "Mac Address"
        },
        component: MacAddressDetailsComponent
      },
      {
        path: "upload-mac-address/:id",
        data: {
          title: "Upload Mac Address"
        },
        component: UploadMacAddressComponent
      },

      {
        path: "mac-address-list",
        data: {
          title: "Mac Address List"
        },
        component: MacAddressListComponent

      },










      {
        path: 'survey',
        loadChildren: () => import('./survey-list/survey.module').then(m => m.SurveyModule)
      },


      {
        path: "upload-exam-os",
        data: {
          title: "Exam OS"
        },
        component: UploadExamOSComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagerRouteModule { }
